import _get from "lodash/get";
import { UpdatedLocationDetails } from "@/redux/slice/location/types/UpdatedLocationDetails";
import checkServiceAvailabilityApi from "@/redux/slice/location/apis/checkServiceAvailability";
import { ServiceAvailabilityResponse } from "@/redux/slice/location/interfaces/ServiceAvailabilityResponse";
import {
  updateAddressLoading,
  updateAlertMessage,
  updateHeaderPincodeError,
  updateIsAlertOpen,
  updateIsPincodeServiceable,
  updatePlaceDetailsStatus,
  updateShowPincodeModal,
  updateSpecifiedLocation,
} from "@/redux/slice/location/slice";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";

const isServiceable = ({ pincode, latitude, longitude, authToken }: UpdatedLocationDetails, dispatch) => {
  checkServiceAvailabilityApi({ pincode, latitude, longitude, authToken })
    .then(
      ({
        serviceable,
        latitude: updatedLat,
        longitude: updatedLong,
        pincode: updatedPincode,
        city: updatedCity,
        state: updatedState,
        tatInput,
      }: ServiceAvailabilityResponse) => {
        if (serviceable) {
          dispatch(updateShowPincodeModal(false));
          dispatch(updateHeaderPincodeError(false));
          dispatch(updateIsPincodeServiceable(true));
          dispatch(
            updateSpecifiedLocation({
              latitude: updatedLat,
              longitude: updatedLong,
              city: updatedCity,
              state: updatedState,
              pincode: updatedPincode,
              tatInput,
            })
          );
          dispatch(updatePlaceDetailsStatus(ThunkResolvedStatus.fulfilled));
        } else {
          dispatch(updateIsPincodeServiceable(false));
          dispatch(updateHeaderPincodeError(true));
          dispatch(updateAddressLoading(false));
        }
      }
    )
    .catch((error) => {
      console.error("Serviceability API failed", error);
      dispatch(updateShowPincodeModal(false));
      dispatch(updateAlertMessage("Location is not serviceable :("));
      dispatch(updateIsAlertOpen(true));
      dispatch(updateIsPincodeServiceable(false));
      dispatch(updateAddressLoading(false));
    });
};

export default isServiceable;
